import {
  GET_LABREQUESTSURVEYRESP,
  GET_LABREQUESTSURVEYRESP_FAIL,
  GET_LABREQUESTSURVEYRESP_SUCCESS,
  GET_LABREQUESTSURVEYRESPS,
  GET_LABREQUESTSURVEYRESPS_FAIL,
  GET_LABREQUESTSURVEYRESPS_SUCCESS,
  ADD_NEW_LABREQUESTSURVEYRESP,
  ADD_LABREQUESTSURVEYRESP_SUCCESS,
  ADD_LABREQUESTSURVEYRESP_FAIL,
  UPDATE_LABREQUESTSURVEYRESP,
  UPDATE_LABREQUESTSURVEYRESP_SUCCESS,
  UPDATE_LABREQUESTSURVEYRESP_FAIL,
  DELETE_LABREQUESTSURVEYRESP,
  DELETE_LABREQUESTSURVEYRESP_SUCCESS,
  DELETE_LABREQUESTSURVEYRESP_FAIL,
  SET_STATE_LABREQUESTSURVEYRESP
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTSURVEYRESP,
  payload: loading,
})

export const getLabRequestSurveyResps = ( params ) => ({
  type: GET_LABREQUESTSURVEYRESPS,
  payload: { params },
})

export const getLabRequestSurveyRespsSuccess = (labRequestSurveyResps, totalPages, currentPage) => ({
  type: GET_LABREQUESTSURVEYRESPS_SUCCESS,
  payload: { labRequestSurveyResps:labRequestSurveyResps, total:totalPages, currentPage:currentPage}
})

export const getLabRequestSurveyRespsFail = error => ({
  type: GET_LABREQUESTSURVEYRESPS_FAIL,
  payload: error,
})

export const addNewLabRequestSurveyResp = labRequestSurveyResp => ({
  type: ADD_NEW_LABREQUESTSURVEYRESP,
  payload: labRequestSurveyResp,
})

export const addLabRequestSurveyRespSuccess = labRequestSurveyResp => ({
  type: ADD_LABREQUESTSURVEYRESP_SUCCESS,
  payload: labRequestSurveyResp,
})  

export const addLabRequestSurveyRespFail = error => ({
  type: ADD_LABREQUESTSURVEYRESP_FAIL,
  payload: error,
})

export const updateLabRequestSurveyResp = labRequestSurveyResp => ({
  type: UPDATE_LABREQUESTSURVEYRESP,
  payload: labRequestSurveyResp,
})

export const updateLabRequestSurveyRespSuccess = labRequestSurveyResp => ({
  type: UPDATE_LABREQUESTSURVEYRESP_SUCCESS,
  payload: labRequestSurveyResp,
})

export const updateLabRequestSurveyRespFail = error => ({
  type: UPDATE_LABREQUESTSURVEYRESP_FAIL,
  payload: error,
})

export const deleteLabRequestSurveyResp = labRequestSurveyResp => ({
  type: DELETE_LABREQUESTSURVEYRESP,
  payload: labRequestSurveyResp,
})

export const deleteLabRequestSurveyRespSuccess = id => ({
  type: DELETE_LABREQUESTSURVEYRESP_SUCCESS,
  id,
})

export const deleteLabRequestSurveyRespFail = error => ({
  type: DELETE_LABREQUESTSURVEYRESP_FAIL,
  payload: error,
})

export const getLabRequestSurveyResp = () => ({
  type: GET_LABREQUESTSURVEYRESP,
})

export const getLabRequestSurveyRespSuccess = labRequestSurveyResp => ({
  type: GET_LABREQUESTSURVEYRESP_SUCCESS,
  payload: labRequestSurveyResp,
})

export const getLabRequestSurveyRespFail = error => ({
  type: GET_LABREQUESTSURVEYRESP_FAIL,
  payload: error,
})
